<template>
  <v-container>
    <v-form ref="form" class="" v-if="!isIssueArea">
      <v-container>
        <v-row justify="center">
          <v-col cols="12" xl="6" lg="6" md="6">
            <v-autocomplete v-model="form.landUse" :rules="landUseRules" :items="land_use"
              :label="translations.select_land_use" outlined clearable background-color="white" dense></v-autocomplete>
          </v-col>
        </v-row>
        <v-row v-if="seen" class="mt-0">
          <v-col cols="12" xl="6" lg="6" md="6" :class="this.$vuetify.breakpoint.name == 'xl' ||
              this.$vuetify.breakpoint.name == 'lg' ||
              this.$vuetify.breakpoint.name == 'md'
              ? 'pr-10'
              : ''
            ">
            <v-row>
              <v-col class="pb-0">
                <span class="secondary--text mb-1">{{
                  translations.general_description
                  }}</span>
                <v-textarea class="pt-1 pb-0 mb-0" v-model="form.overview" 
                  :label="translations.label_description" outlined clearable solo background-color="white"
                  ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pb-0">
                <v-icon color="primary" class="mb-1 mr-1">mdi-sprinkler</v-icon><span class="secondary--text mb-1">{{
                  translations.irrigation_system_label
                  }}</span>
                <v-autocomplete class="pt-1 pb-0 mb-0" v-model="form.irrigation" :items="irrigation_system"
                  :label="translations.selectIrrigationSystem" outlined clearable solo background-color="white"
                  dense></v-autocomplete>
              </v-col>
            </v-row>
            <v-row class="mt-0 pt-1">
              <v-col cols="12" class="mt-0 pt-0">
                <v-icon color="primary" class="mb-1 mr-1">mdi-land-fields</v-icon>
                <span class="secondary--text mb-1">
                  {{ translations.management_label }}
                </span>
              </v-col>
              <v-col cols="12" class="pt-1 pb-0 mb-0">
                <v-autocomplete v-model="form.shadow" :items="type_manage"
                  :label="translations.label_select_shadow_type" outlined clearable background-color="white"
                  dense></v-autocomplete>
              </v-col>
              <v-col cols="12" class="mt-0 pt-0">
                <span class="secondary--text mb-1">
                  {{
                    translations.label_what_is_your_agricultural_management_practice
                  }}
                </span>
              </v-col>
              <v-col cols="12" class="py-0">
                <div class="box-rounded">
                  <v-row class="ma-1">
                    <v-col v-for="(n, index) in management_items" :key="index" cols="12" class="py-0 my-0">
                      <v-checkbox dense v-model="n.model" :label="`${n.text}`" :key="index"
                        @change="verifyOption(n), validateForm()"></v-checkbox>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col cols="12" v-if="activeManagementDescription">
                <v-textarea class="pt-1" outlined v-model="form.descriptionOtherAgriculturalManagementPractice" solo
                  name="input-5-2" label="Descripción de manejo"></v-textarea>
              </v-col>
              <v-col cols="12" class="pt-5">
                <div class="box-rounded">
                  <v-radio-group v-model="form.management_2" row>
                    <v-row>
                      <v-col v-for="(n, index) in management_items_2" :key="index" class="d-flex justify-center">
                        <v-radio class="grayColor" color="orange darken-1" :key="index" :label="`${n.text}`"
                          :value="n.value"></v-radio>
                      </v-col>
                    </v-row>
                  </v-radio-group>
                </div>
              </v-col>
            </v-row>

            <v-row class="mb-0 pb-0">
              <v-col class="mb-0 pb-0">
                <v-icon color="primary" class="mb-1 mr-1">mdi-flag-checkered</v-icon>
                <span class="secondary--text mb-1">
                  {{ translations.label_crop_success_definition }}
                </span>
                <v-textarea class="pt-1" outlined v-model="form.successDefinition" solo name="input-7-4"
                  :label="translations.label_description"></v-textarea>
              </v-col>
            </v-row>

            <v-row class="mt-0 pt-0">
              <v-col class="mt-0 pt-0">
                <v-icon color="primary" class="mb-1 mr-1">mdi-sprout</v-icon>
                <span class="secondary--text mb-1">
                  {{ translations.label_crop_cycle }}
                </span>
                <v-autocomplete class="pt-1 pb-0 mb-0" v-model="form.cropCycle" :items="crop_items"
                  :label="translations.label_select_crop" solo :rules="cropRules" dense outlined></v-autocomplete>
                <!-- <span class="secondary--text mb-1"> Variedad </span> -->
                <v-text-field v-model="form.variety" background-color="white" outlined dense
                  :label="translations.label_variety_optional"></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="6" class="pt-0 pb-5 text-center">
                <div class="box-rounded py-3">
                  <p class="mb-2 font-weight-bold text-center">
                    {{ translations.label_cycle_start }}
                  </p>
                  <v-row class="d-flex justify-center">
                    <p class="grayColor font-weight-thin my-2 mr-1">
                      {{ pickerInit }}
                    </p>
                    <v-icon @click.stop="dialogDatePickerInit = true" color="warning" class="my-2">mdi-calendar</v-icon>
                  </v-row>
                  <span v-if="showStartError" class="small-text text-center">{{
                    translations.field_required
                    }}</span>
                </div>
              </v-col>
              <v-col cols="6" class="pt-0 pb-5 text-center">
                <div class="box-rounded py-3">
                  <p class="mb-2 font-weight-bold text-center">
                    {{ translations.label_cycle_end }}
                  </p>
                  <v-row class="d-flex justify-center">
                    <p class="grayColor font-weight-thin my-2 mr-1">
                      {{ pickerEnd }}
                    </p>
                    <v-icon @click.stop="dialogDatePickerEnd = true" color="primary" class="my-2">mdi-calendar</v-icon>
                  </v-row>
                  <span v-if="showEndError" class="small-text text-center">{{
                    translations.field_required
                    }}</span>
                </div>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" xl="6" lg="6" md="6" :class="this.$vuetify.breakpoint.name == 'xl' ||
              this.$vuetify.breakpoint.name == 'lg' ||
              this.$vuetify.breakpoint.name == 'md'
              ? 'pl-10'
              : ''
            ">
            <v-row v-if="
              this.$vuetify.breakpoint.name != 'xl' &&
              this.$vuetify.breakpoint.name != 'lg' &&
              this.$vuetify.breakpoint.name != 'md'
            ">
              <v-col cols="12">
                <v-divider></v-divider>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12" class="mt-0 pt-0">
                <span class="secondary--text mb-1">
                  {{
                    translations.label_list_of_inputs_applied_during_crop_cycle
                  }}
                </span>
              </v-col>
              <v-col cols="12">
                <div class="box-rounded">
                  <v-row class="ma-1">
                    <v-col v-for="(n, index) in agroinputs" :key="index" cols="12" class="py-0 my-0">
                      <v-checkbox dense v-model="n.model" :label="`${n.text}`" :key="index"
                        @change="validateForm()"></v-checkbox>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col cols="12" class="my-0 py-0">
                <div v-for="(n, index) in agroinputs" :key="index">
                  <v-row class="my-0 py-0">
                    <v-col cols="12" class="my-0 py-0">
                      <v-text-field v-if="n.model" dense background-color="white" outlined :label="n.label"
                        v-model="n.description"></v-text-field>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12" class="mt-0 pt-0">
                <span class="secondary--text mb-1">
                  {{ translations.label_average_yield_per_hectare_acre }}
                </span>
              </v-col>
              <v-col cols="12" class="my-0 py-0">
                <v-text-field v-model="form.tonnageYield" background-color="white" outlined dense
                  :label="translations.label_tonnage"></v-text-field>
              </v-col>
              <v-col cols="12" class="my-0 py-0">
                <v-autocomplete v-model="form.tonnageYieldUnits" :items="tonnageUnits"
                  :label="translations.label_select_tonnage_unit" outlined clearable background-color="white"
                  dense></v-autocomplete>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12" class="mt-0 pt-0">
                <v-icon color="primary" class="mb-1 mr-1">mdi-alert-decagram</v-icon>
                <span class="secondary--text mb-1">
                  {{ translations.label_problems_detected }}
                </span>
              </v-col>
              <v-col>
                <div class="box-rounded">
                  <v-row class="ma-2">
                    <v-col v-for="(n, index) in issueList" :key="index" cols="12" class="py-0 my-0">
                      <v-checkbox dense v-model="n.model" :label="`${n.text}`" :key="index"
                        @change="validateForm()"></v-checkbox>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col cols="12" class="mb-0 pb-0">
                <v-textarea class="pt-1" outlined v-model="form.issueDescription" solo name="input-7-4"
                  :label="translations.label_description"></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-divider></v-divider>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-icon color="primary" class="mb-1 mr-1">mdi-sprout</v-icon>
                <span class="secondary--text mb-1">
                  {{ translations.label_previous_cycle }}
                </span>
                <v-autocomplete class="pb-0 mb-0" v-model="form.cropCycleLast" :items="crop_items"
                  :label="translations.label_select_crop" solo dense outlined></v-autocomplete>
                <!-- <span class="secondary--text mb-1"> Variedad </span> -->
                <v-text-field v-model="form.varietyLast" outlined dense background-color="white"
                  :label="translations.label_variety_optional"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="justify-center">
              <v-col cols="10" xl="8">
                <v-container class="box-rounded" @click="goToIssueArea">
                  <v-row align="center">
                    <v-col cols="3" lg="3">
                      <v-icon size="30">mdi-map-marker-plus</v-icon>
                    </v-col>
                    <v-col cols="9" lg="8" md="8">
                      <v-row>
                        <v-col cols="10" class="pr-0">
                          <span class="
                              text-font-bold
                              secondary--text
                              text-caption
                              text-sm-subtitle-2
                              text-md-subtitle-2
                              text-lg-subtitle-2
                              text-xl-subtitle-2
                            ">{{
                              translations.label_add_area_with_highest_problem_severity
                            }}</span>
                        </v-col>
                        <v-col cols="2" class="pl-1" v-if="issueArea.length > 0">
                          <v-icon size="20" color="primary">mdi-check-circle</v-icon>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>

      <!-- Dialogs -->
      <dialog-date-picker v-model="dialogDatePickerInit" @picker="getInitPicker"></dialog-date-picker>
      <dialog-date-picker v-model="dialogDatePickerEnd" @picker="getEndPicker"></dialog-date-picker>
      <!-- Dialogs -->
      <v-dialog v-model="dialogAgronomic" persistent max-width="290">
        <v-card>
          <v-card-title class="text-h6">
            {{ translations.label_new_crop_cycle }}
          </v-card-title>
          <v-card-text>
            {{ translations.label_crop_cycle_ended }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="setNewCycle(false)">
              {{ translations.not }}
            </v-btn>
            <v-btn color="green darken-1" text @click="setNewCycle(true)">
              {{ translations.yes }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
    <div v-else>
      <v-btn color="primary" elevation="15" fab small @click="closeMap" class="mb-3 back-button">
        <v-icon> mdi-arrow-left </v-icon>
      </v-btn>
      <IssueArea />
    </div>
  </v-container>
</template>

<script>
import moment from "moment";
// Vuex
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
// Validations
import {
  requiredValidation,
  requiredFValidation,
} from "@/helpers/validations.js";
// Components
import DialogDatePicker from "./modals/DialogDatePicker.vue";
import IssueArea from "@/components/territory/IssueArea.vue";

export default {
  data: () => ({
    // items
    land_use: [],
    irrigation_system: [],
    management_items: [],
    management_items_2: [],
    agroinputs: [],
    issueList: [],
    type_manage: [],
    tonnageUnits: [],
    crop_items: [],
    // selected
    dialogAgronomic: false,
    dialogDatePickerInit: false,
    dialogDatePickerEnd: false,
    pickerInit: "",
    pickerEnd: "",
    crop_selected: null,
    seen: false,
    // rules
    landUseRules: null,
    irrigationRules: null,
    shadowRules: null,
    managementRules: null,
    management2Rules: null,
    descriptionSuccesRules: null,
    cropRules: null,
    startDateCycleRules: null,
    endDateCycleRules: null,
    // object form
    form: {
      area: "",
      landUse: "",
      irrigation: "",
      shadow: "",
      management: "",
      management_2: "",
      cropCycle: "",
      variety: "",
      startDate: "",
      endDate: "",
      cropCycleId: null,
      successDefinition: "",
      cropCycleLast: "",
      varietyLast: "",
      issueDescription: "",
      issueArea: [],
      agriculturalManagementPractices: [],
      inputsOnCrop: {
        inputFungi: "",
        inputConditionerDescription: "",
        inputPhytopathogenDescription: "",
        inputFungiDescription: "",
        inputWeed: "",
        inputPest: "",
        inputPhytopathogen: "",
        inputPestDescription: "",
        inputBacteriaDescription: "",
        inputWeedDescription: "",
        inputConditioner: "",
        inputBacteria: "",
      },
      detectedIssues: {},
      tonnageYield: null,
      tonnageYieldUnits: null,
    },
    activeManagementDescription: false,
    showEndError: false,
    showStartError: false,
  }),
  components: {
    DialogDatePicker,
    IssueArea,
  },
  async created() {
    this.land_use = [
      {
        text: this.translations.landUse_list["sterile"],
        value: "sterile",
      },
      {
        text: this.translations.landUse_list["cropLand"],
        value: "cropLand",
      },
    ];
    this.irrigation_system = [
      {
        text: this.translations.irrigations_list["drip"],
        value: "drip",
      },
      {
        text: this.translations.irrigations_list["pivot"],
        value: "pivot",
      },
      {
        text: this.translations.irrigations_list["wheeled"],
        value: "wheeled",
      },
      {
        text: this.translations.irrigations_list["microspray"],
        value: "microspray",
      },
      {
        text: this.translations.irrigations_list["without irrigation"],
        value: "without irrigation",
      },
    ];
    this.type_manage = [
      {
        text: this.translations.shadow_type["Shade cloth"],
        value: "Shade cloth",
      },
      {
        text: this.translations.shadow_type["Greenhouse"],
        value: "Greenhouse",
      },
      {
        text: this.translations.shadow_type["Open field"],
        value: "Open field",
      },
      {
        text: this.translations.shadow_type["Macrotunnel"],
        value: "Macrotunnel",
      },
    ];
    this.management_items = [
      {
        text: this.translations.management_practices["TILLAGE"],
        value: "TILLAGE",
        model: false,
      },
      {
        text: this.translations.management_practices["CROP_ROTATION"],
        value: "CROP_ROTATION",
        model: false,
      },
      {
        text: this.translations.management_practices["COMPOST_APPLY"],
        value: "COMPOST_APPLY",
        model: false,
      },
      {
        text: this.translations.management_practices["CROP_COVER"],
        value: "CROP_COVER",
        model: false,
      },
      {
        text: this.translations.management_practices["PEST_MANAGEMENT"],
        value: "PEST_MANAGEMENT",
        model: false,
      },
      {
        text: this.translations.management_practices["OTHER"],
        value: "OTHER",
        model: false,
      },
      {
        text: this.translations.management_practices["NONE"],
        value: "NONE",
        model: false,
      },
    ];
    this.management_items_2 = [
      {
        text: this.translations.propagation_method["graft"],
        value: "graft",
      },
      {
        text: this.translations.propagation_method["frank"],
        value: "frank",
      },
    ];
    this.agroinputs = [
      {
        text: this.translations.agroinputs["inputWeed"],
        value: "inputWeed",
        model: false,
        description: "",
        label: this.translations.agroinputs_descriptions["inputWeed"],
      },
      {
        text: this.translations.agroinputs["inputPest"],
        value: "inputPest",
        model: false,
        description: "",
        label: this.translations.agroinputs_descriptions["inputPest"],
      },
      {
        text: this.translations.agroinputs["inputPhytopathogen"],
        value: "inputPhytopathogen",
        model: false,
        description: "",
        label: this.translations.agroinputs_descriptions["inputPhytopathogen"],
      },
      {
        text: this.translations.agroinputs["inputConditioner"],
        value: "inputConditioner",
        model: false,
        description: "",
        label: this.translations.agroinputs_descriptions["inputConditioner"],
      },
      {
        text: this.translations.agroinputs["inputFungi"],
        value: "inputFungi",
        model: false,
        description: "",
        label: this.translations.agroinputs_descriptions["inputFungi"],
      },
      {
        text: this.translations.agroinputs["inputBacteria"],
        value: "inputBacteria",
        model: false,
        description: "",
        label: this.translations.agroinputs_descriptions["inputBacteria"],
      },
      {
        text: this.translations.agroinputs["inputAlgae"],
        value: "inputAlgae",
        model: false,
        description: "",
        label: this.translations.agroinputs_descriptions["inputAlgae"],
      },
    ];
    this.tonnageUnits = [
      {
        text: this.translations.tonnageUnits["HECTARE"],
        value: "HECTARE",
      },
      {
        text: this.translations.tonnageUnits["ACRE"],
        value: "ACRE",
      },
    ];
    this.issueList = [
      {
        text: this.translations.issueList["salinity"],
        value: "salinity",
        model: false,
      },
      {
        text: this.translations.issueList["soilCompaction"],
        value: "soilCompaction",
        model: false,
      },
      {
        text: this.translations.issueList["alkalinity"],
        value: "alkalinity",
        model: false,
      },
      {
        text: this.translations.issueList["acidity"],
        value: "acidity",
        model: false,
      },
      {
        text: this.translations.issueList["heavyMetals"],
        value: "heavyMetals",
        model: false,
      },
      {
        text: this.translations.issueList["recurrentDiseases"],
        value: "recurrentDiseases",
        model: false,
      },
      {
        text: this.translations.issueList["percentageOrganicMatter"],
        value: "percentageOrganicMatter",
        model: false,
      },
      {
        text: this.translations.issueList["other"],
        value: "other",
        model: false,
      },
    ];
    this.landUseRules = requiredValidation(this.translations.field_required);
    this.irrigationRules = requiredValidation(this.translations.field_required);
    this.shadowRules = requiredValidation(this.translations.field_required);
    this.managementRules = requiredValidation(this.translations.field_required);
    this.management2Rules = requiredValidation(
      this.translations.field_required
    );
    this.descriptionSuccesRules = requiredValidation(
      this.translations.field_required
    );
    this.cropRules = requiredValidation(this.translations.field_required);
    this.startDateCycleRules = requiredValidation(
      this.translations.field_required
    );
    this.endDateCycleRules = requiredValidation(
      this.translations.field_required
    );
  },
  async mounted() {
    try {
      this.SET_LOADER(true);
      if (!this.areaSelected) {
        let response = await this.getAreaById(this.$route.params.areaId);
        if (response) {
          if (!response.error) {
            this.SET_AREA_SELECTED(response.soilArea);
            await this.setCrop();
          } else {
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text: this.translations.advice_error,
              timeout: 4000,
            });
          }
        } else {
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: this.translations.advice_error,
            timeout: 4000,
          });
        }
      } else {
        this.setCrop();
      }
    } catch (e) {
      console.log(e);
      this.SET_ALERT_TYPE({
        visible: true,
        type: "error",
        text: this.translations.advice_error,
        timeout: 4000,
      });
    }
    this.SET_LOADER(false);
  },
  watch: {
    "form.landUse"(newVal, oldVal) {
      if (newVal === "sterile" || newVal === "" || newVal === null) {
        this.seen = false;
        this.cleanInputs();
      } else {
        this.seen = true;
      }
    },
    pickerEnd() {
      if (this.pickerEnd.length <= 0) {
        this.showEndError = true;
      } else {
        this.showEndError = false;
      }
    },
    pickerInit() {
      if (this.pickerInit.length <= 0) {
        this.showStartError = true;
      } else {
        this.showStartError = false;
      }
    },
  },
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    ...mapState("areasList", ["areaSelected", "crops"]),
    ...mapState("agronomic", ["issueArea", "isIssueArea"]),
    ...mapState(["appBarOptions"]),
  },
  methods: {
    ...mapActions("agronomic", [
      "updateCropCycle",
      "getCropCycle",
      "getLastCrop",
    ]),
    ...mapActions("areasList", ["getAreaById"]),
    ...mapActions(["uploadFile"]),
    ...mapMutations(["SET_APPBAR_OPTIONS", "SET_LOADER"]),
    ...mapMutations("areasList", ["SET_AREA_SELECTED"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapMutations("agronomic", [
      "SET_FORM",
      "SET_ISSUE_AREA",
      "CLEAN_ISSUE_AREA",
    ]),
    closeMap() {
      this.SET_FORM(false);
    },
    getInitPicker(e) {
      this.pickerInit = this.getFormattedSimple(e);
    },
    getEndPicker(e) {
      this.pickerEnd = this.getFormattedSimple(e);
    },
    setCropItems() {
      let cropsArray = Object.entries(this.translations.crop_name_list);
      for (let crop of cropsArray) {
        this.crop_items.push({
          text: crop[1],
          value: crop[0],
        });
      }
    },
    async assignData() {
      let cropResponse = this.crop_selected;
      if (cropResponse != null) {
        if (this.areaSelected.landUse) {
          this.form.landUse = this.areaSelected.landUse;
          this.form.cropCycleId = cropResponse._id;
        }
        if (this.areaSelected.landUse === "cropLand") {
          this.form.irrigation = this.areaSelected.irrigationSystem;

          let manage_2 = "";

          if (cropResponse.crop.isGraft) {
            manage_2 = "graft";
          }
          if (cropResponse.crop.isFrank) {
            manage_2 = "frank";
          }
          this.form.management_2 = manage_2;

          this.form.cropCycle = cropResponse.crop.cropName;
          this.form.variety = cropResponse.crop.variety;
          this.pickerInit = cropResponse.plantDate;
          this.pickerEnd = cropResponse.harvestDate;
          this.form.overview = cropResponse.crop.overview;
          this.form.successDefinition = cropResponse.crop.descriptionCropSuccess
            ? cropResponse.crop.descriptionCropSuccess
            : "";
          this.form.issueDescription = cropResponse.crop.descriptionIssue
            ? cropResponse.crop.descriptionIssue
            : "";
          this.form.cropCycleLast = cropResponse.crop.lastCrop
            ? cropResponse.crop.lastCrop
            : "";
          this.form.varietyLast = cropResponse.crop.lastVariety
            ? cropResponse.crop.lastVariety
            : "";
          this.form.shadow = cropResponse.crop.shadowMesh
            ? cropResponse.crop.shadowMesh
            : "";

          for (let item of this.management_items) {
            if (
              cropResponse.crop.agriculturalManagementPractices.find(
                (element) => element == item.value
              )
            ) {
              item.model = true;
            }
          }

          for (let item of this.agroinputs) {
            if (cropResponse.crop.inputsOnCrop && cropResponse.crop.inputsOnCrop[item.value] == true) {
              item.model = true;
              item.description =
                cropResponse.crop.inputsOnCrop[`${item.value}Description`];
            }
          }

          this.form.tonnageYield = cropResponse.crop.tonnageYield;
          this.form.tonnageYieldUnits = this.tonnageUnits.find(
            (element) => element.value == cropResponse.crop.tonnageYieldUnits
          );

          for (let item of this.issueList) {
            if (cropResponse.crop.detectedIssues && cropResponse.crop.detectedIssues[item.value] == true) {
              item.model = true;
            }
          }
          // this.form.issueArea = cropResponse.crop.issueArea;
          if (this.issueArea.length === 0) {
            if (cropResponse.crop.issueArea) {
              this.SET_ISSUE_AREA(cropResponse.crop.issueArea);
            }
          }

          if (cropResponse.plantDate != "" && cropResponse.harvestDate != "") {
            var firstDate = moment(cropResponse.plantDate, [
              "MM-DD-YYYY",
              "YYYY-MM-DD",
            ]);
            var secondDate = moment(cropResponse.harvestDate, [
              "MM-DD-YYYY",
              "YYYY-MM-DD",
            ]);
            if (firstDate.isValid() && secondDate.isValid()) {
              const end = secondDate.valueOf();
              const now = moment().valueOf();

              var diffPartial = end - now;

              var elapseDays = diffPartial / (24 * 60 * 60 * 1000);

              if (elapseDays < 0) {
                this.dialogAgronomic = true;
              }
            }
          }
        }
      }
    },
    async saveAgronomic() {
      try {
        if (this.$refs.form.validate()) {
          this.SET_LOADER(true);
          this.form.area = this.areaSelected._id;
          this.form.issueArea = this.issueArea;
          if (this.pickerInit.length > 0) {
            this.form.startDate = this.getFormattedSimple(this.pickerInit);
          } else {
            this.form.startDate = "";
          }
          if (this.pickerEnd.length > 0) {
            this.form.endDate = this.getFormattedSimple(this.pickerEnd);
          } else {
            this.form.endDate = "";
          }

          //set data
          this.form.agriculturalManagementPractices = this.management_items
            .filter((element) => element.model == true)
            .map((element) => element.value);

          this.form.inputsOnCrop = this.agroinputs.reduce((obj, item) => {
            obj[item.value] = item.model;
            obj[`${item.value}Description`] = item.description;
            return obj;
          }, {});

          this.form.detectedIssues = this.issueList.reduce((obj, item) => {
            obj[item.value] = item.model;
            return obj;
          }, {});
          let response = await this.updateCropCycle(this.form);
          if (response) {
            if (!response.error) {
              this.SET_AREA_SELECTED(response.soilArea);
              this.goToTerritory();
              this.SET_ALERT_TYPE({
                visible: true,
                type: "success",
                text: this.translations.label_agronomic_management_saved,
                timeout: 5000,
              });
            } else {
              console.log(response.message);
              this.SET_ALERT_TYPE({
                visible: true,
                type: "error",
                text: this.translations.advice_error,
                timeout: 4000,
              });
            }
          } else {
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text: this.translations.advice_error,
              timeout: 4000,
            });
          }
        }
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.advice_error,
          timeout: 4000,
        });
      }
      this.SET_LOADER(false);
    },
    goToTerritory() {
      this.$router.push("/territory");
    },
    goToIssueArea() {
      this.SET_FORM(true);
      // this.$router.push(`/issue-area/${this.areaSelected._id}`);
    },
    setNewCycle(value) {
      this.dialogAgronomic = false;
      if (value) {
        this.seen = false;
        this.form = {
          area: "",
          landUse: "",
          irrigation: "",
          shadow: "",
          management: "",
          management_2: "",
          cropCycle: "",
          variety: "",
          startDate: "",
          endDate: "",
          cropCycleId: null,
          successDefinition: "",
          cropCycleLast: "",
          varietyLast: "",
          issueDescription: "",
          issueArea: [],
          agriculturalManagementPractices: [],
          inputsOnCrop: {
            inputFungi: "",
            inputConditionerDescription: "",
            inputPhytopathogenDescription: "",
            inputFungiDescription: "",
            inputWeed: "",
            inputPest: "",
            inputPhytopathogen: "",
            inputPestDescription: "",
            inputBacteriaDescription: "",
            inputWeedDescription: "",
            inputConditioner: "",
            inputBacteria: "",
          },
          detectedIssues: {},
        };
      }
    },
    cleanInputs() {
      this.form = {
        area: "",
        landUse: "sterile",
        irrigation: "",
        shadow: "",
        management: "",
        management_2: "",
        cropCycle: "",
        variety: "",
        startDate: "",
        endDate: "",
        cropCycleId: null,
        successDefinition: "",
        cropCycleLast: "",
        varietyLast: "",
        issueDescription: "",
        issueArea: [],
        agriculturalManagementPractices: [],
        inputsOnCrop: {
          inputFungi: "",
          inputConditionerDescription: "",
          inputPhytopathogenDescription: "",
          inputFungiDescription: "",
          inputWeed: "",
          inputPest: "",
          inputPhytopathogen: "",
          inputPestDescription: "",
          inputBacteriaDescription: "",
          inputWeedDescription: "",
          inputConditioner: "",
          inputBacteria: "",
        },
        detectedIssues: {},
        tonnageYield: null,
        tonnageYieldUnits: null,
      };
    },
    async setCrop() {
      try {
        this.setCropItems();
        let response = await this.getLastCrop(this.$route.params.areaId);
        if (response) {
          if (!response.error) {
            if (response.cropCycle) {
              //cropcycle already created get data from it
              this.crop_selected = response.cropCycle;
              await this.assignData();
            } else {
              //new and first crop cycle
               this.form.landUse = "cropLand"
            }
          } else {
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text: this.translations.advice_error,
              timeout: 4000,
            });
          }
        } else {
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: this.translations.advice_error,
            timeout: 4000,
          });
        }
      } catch (e) {
        console.log(e);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.advice_error,
          timeout: 4000,
        });
      }
      this.SET_APPBAR_OPTIONS({
        leftButton: "back-arrow",
        funcLeftButton: this.goToTerritory,
        rightButton: "save",
        funcRightButton: this.saveAgronomic,
      });
    },
    getFormattedSimple(date) {
      return moment(date).format("YYYY/MM/DD");
    },
    verifyOption(item) {
      if (item) {
        if (item.model == true && item.value == "OTHER") {
          this.activeManagementDescription = true;
        }
        if (item.model == false && item.value == "OTHER") {
          this.activeManagementDescription = false;
        }
      }
    },
    validationMultiple(list) {
      return [
        () =>
          list.filter((element) => element.model == true).length != 0 ||
          this.translations.label_at_least_one_item_required,
      ];
    },
    validateForm() {
      this.$refs.form.validate();
    },
  },
  destroyed() {
    this.CLEAN_ISSUE_AREA();
  },
};
</script>

<style scoped>
.small-text {
  font-size: 0.65rem;
  color: red;
}

.box-rounded {
  background: #ffffff;
  border-radius: 13px;
  border: 1px solid #fff !important;
  box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%),
    0 1px 5px 0 rgb(0 0 0 / 12%);
  width: 100%;
  height: auto;
  align-items: center;
}

.v-input--radio-group__input {
  align-self: center;
}

.grayColor {
  color: #818181;
}

.back-button {
  top: 10%;
  margin-left: 30px;
  z-index: 1;
  position: absolute;
}
</style>
